import React, { useEffect, useState } from 'react';
import {
  GetAgencyDetails,
  GetProducersByProducerID,
  GetProducersBySearchName,
  GetAgencyByTeamAgencyDescription,
  GetSupportRegistrationByBaseProducer,
} from 'api/admin';
import { Routes, Route, NavLink } from 'react-router-dom';

import Divider from '@mui/material/Divider';
import { StrikeThroughHeader } from 'Components/Headers/strikethrough-header/strikethrough-header';
//import useProducerClaim from 'Hooks/claims/useProducerClaim/useProducerClaim';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
import SupportStaff from '../SupportStaff/SupportStaff';
import './Index.scss';
import { useUser } from '../../../context/UserContext';
//Utilities
import { useQuery, useMutation } from '@tanstack/react-query';

import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import SearchIcon from '@mui/icons-material/Search';
import { Typography, Stack, Button, Box, CircularProgress, Alert } from '@mui/material';
import NotificationSnackbar from '../../../components/Global/NotificationSnackbar/NotificationSnackbar';

function Index({ ...props }) {
  const user = useUser();
  const [agencyDetails, setAgencyDetails] = useState(null);
  const [selectedProducer, setSelectedProducer] = useState(null);
  const [supportStaff, setSupportStaff] = useState([]);

  const getAgencyDetails = useMutation({
    mutationFn: async (data) => await GetAgencyDetails(data)(),
  });
  const [agencyID, setAgencyID] = useState(null);
  const [teamAgencyDescription, setTeamAgencyDescription] = useState(null);
  const [selectedNpnID, setSelectedNpnID] = useState(null);

  const [openNotif, setOpenNotif] = useState(false);
  const [snackBarSuccessMsg, setSnackBarSuccessMsg] = useState('Support Staff Success');
  const [snackBarErrorMsg, setSnackBarErrorMsg] = useState('Support Staff Error');
  const [snackBarStatus, setSnackBarStatus] = useState('success');

  function supportStaffInfo() {
    return (
      <div>
        This is based on <span style={{ fontWeight: 'bold' }}>NpnID</span> only. The{' '}
        <span style={{ fontWeight: 'bold' }}>ProducerIDs</span> are used for{' '}
        <span style={{ fontWeight: 'bold' }}>Searching</span>.
      </div>
    );
  }

  const getAgencyByTeamAgencyDescription = useMutation({
    mutationFn: async (data) => await GetAgencyByTeamAgencyDescription(data)(),
  });

  const getProducersByProducerID = useMutation({
    mutationFn: async (data) => await GetProducersByProducerID(data)(),
  });

  const getProducersBySearchName = useMutation({
    mutationFn: async (data) => await GetProducersBySearchName(data)(),
  });

  const getSupportReg = useMutation({
    mutationFn: async (data) => await GetSupportRegistrationByBaseProducer(data)(),
  });

  function GetDetailsOfAgency(agencyID) {
    getAgencyDetails.mutate(
      { AgencyID: agencyID },
      {
        onSuccess: (d) => {
          setAgencyDetails(JSON.parse(d));
        },
      }
    );
  }

  function SearchByID() {
    if (searchProducerID === '' || searchProducerID === null) return;

    getProducersByProducerID.mutate(
      { ProducerID: searchProducerID },
      {
        onSuccess: (d) => {
          setProducerSearchResultsByID(d);
          SelectProducer(d.length > 0 ? d[0] : null);
        },
      }
    );
  }

  function SearchByName() {
    if (searchName === '' || searchName === null) return;

    getProducersBySearchName.mutate(
      { ProducerID: searchName },
      {
        onSuccess: (d) => {
          setProducerSearchResultsByName(d);
          SelectProducer(d.length > 0 ? d[0] : null);
        },
      }
    );
  }
  function IsLoading() {
    return (
      getAgencyDetails.isLoading ||
      getAgencyDetails.isFetching ||
      getAgencyByTeamAgencyDescription.isLoading ||
      getAgencyByTeamAgencyDescription.isFetching ||
      getSupportReg.isLoading ||
      getSupportReg.isFetching ||
      getProducersByProducerID.isLoading ||
      getProducersByProducerID.isFetching
    );
  }

  function SelectProducerSupportStaff(p) {
    setSelectedProducer(p);

    if (p === null) return;
    if (p.avX_NPN === 'HO') return;

    getAgencyByTeamAgencyDescription.mutate(
      { ProducerID: p.teamAgencyDescription },
      {
        onSuccess: (d) => {
          GetDetailsOfAgency(d.id);
        },
      }
    );
    getSupportReg.mutate(
      { BaseProducerIDs: [p.avX_NPN] },
      {
        onSuccess: (d) => {
          if (d && JSON.parse(d).length > 0) {
            setSupportStaff(JSON.parse(d));
          } else {
            setSupportStaff([]);
          }
        },
      }
    );
  }

  function refresh() {
    if (selectedProducer == null) return;
    if (selectedProducer.avX_NPN === 'HO') return;

    getSupportReg.mutate(
      { BaseProducerIDs: [selectedProducer.avX_NPN] },
      {
        onSuccess: (d) => {
          if (d && JSON.parse(d).length > 0) {
            setSupportStaff(JSON.parse(d));
          } else {
            setSupportStaff([]);
          }
        },
      }
    );
  }

  if (user == null)
    return (
      <>
        <Stack
          justifyContent={'space-between'}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          direction={{ xs: 'column', md: 'row' }}
        >
          <Typography component={'h3'} sx={{ padding: '1rem 0' }} variant="h6">
            Support Staff
          </Typography>
          <Stack
            direction="row"
            gap={2}
            width={{ xs: '100%', md: 'unset' }}
            justifyContent={{ xs: 'flex-end', md: 'unset' }}
            padding={{ xs: '.5rem 0', md: 'unset' }}
          >
            <CircularProgress />
          </Stack>
        </Stack>
      </>
    );

  const ShowSupportStaffModal = () => {
    return agencyDetails != null && selectedProducer != null ? (
      <SupportStaff
        baseProducer={user.producerID.split(',')[0]}
        codes={agencyDetails.Codes}
        selectedProducer={selectedProducer}
        supportStaff={supportStaff}
        refresh={refresh}
        isLoading={getSupportReg.isLoading || getSupportReg.isFetching}
        ShowNotificationSnackbar={ShowNotificationSnackbar}
      />
    ) : (
      <div></div>
    );
  };

  return (
    <Box sx={{ padding: '1rem' }}>
      <NotificationSnackbar
        status={snackBarStatus}
        openTrigger={openNotif}
        onClose={() => {
          setOpenNotif(false);
        }}
        successMsg={snackBarSuccessMsg}
        errorMsg={snackBarErrorMsg}
      />

      <Stack
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        direction={{ xs: 'column', md: 'row' }}
      >
        <Typography component={'h3'} sx={{ padding: '1rem 0' }} variant="h6">
          Support Staff
        </Typography>
        <Stack
          direction="row"
          gap={2}
          width={{ xs: '100%', md: 'unset' }}
          justifyContent={{ xs: 'flex-end', md: 'unset' }}
          padding={{ xs: '.5rem 0', md: 'unset' }}
        >
          <Button
            sx={{
              backgroundColor: '#1976d2',
              fontSize: 'medium',
              color: 'white',
              height: 'fit-content',
              padding: '.5rem .95rem',
            }}
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={() => {
              if (props.npnID && props.npnID !== '') {
                getProducersByProducerID.mutate(
                  { ProducerID: props.npnID },
                  {
                    onSuccess: (d) => {
                      // setProducerSearchResultsByID and SelectProducer are
                      // referenced elsewhere in this file but never defined.
                      // Falling back to the existing setSelectedProducer state.
                      setSelectedProducer(d && d.length > 0 ? d[0] : null);
                    },
                  }
                );
              }
            }}
          >
            {'Search'}
          </Button>
        </Stack>
      </Stack>

      <Alert severity="warning" color="warning" style={{ backgroundColor: 'rgb(255, 244, 229)' }}>
        {supportStaffInfo()}
      </Alert>

      {agencyID == null && (
        <Box sx={{ padding: '1rem' }}>
          {teamAgencyDescription == null
            ? 'Please Select an Agency to Search'
            : "Can't find Registration Codes for " + teamAgencyDescription}
        </Box>
      )}

      <div id="home-office-actions" className="pt-2">
        {IsLoading() ? (
          <CircularProgress />
        ) : (
          <>
            <Divider style={{ margin: '1em 0' }} />
            {selectedProducer != null && (
              <label style={{ margin: '1em 0', fontWeight: '500', fontSize: 'large' }}>
                Current Producer Selected:{' '}
                {selectedProducer.printName + ' - ' + selectedProducer.teamAgencyDescription}
              </label>
            )}
            <ShowSupportStaffModal />
          </>
        )}
      </div>
    </Box>
  );
}

export { Index };
